(function () {
    'use strict';

    var SLIDER_CLASS = 'tabs-ic-slider';
    var PREFIX = 'ic';

    var MOBILE_MAP = { '1': 1.2, '2': 2.2 };
    var TABLET_MAP = { '2': 2.5, '3': 2.5, '4': 3.5 };
    var DESKTOP_MAP = { '2': 2.5, '3': 3.5, '4': 3.5, '5': 3.5, '6': 3.5 };

    function initSlider(sliderEl) {
        if (!sliderEl || sliderEl.dataset[PREFIX + 'Initialized'] === 'true') return;

        var swiperEl = sliderEl.querySelector('.swiper');
        if (!swiperEl || typeof FoxTheme === 'undefined' || !FoxTheme.Carousel) return;

        var colsMobile = sliderEl.dataset.colsMobile || '1';
        var colsTablet = sliderEl.dataset.colsTablet || '3';
        var colsDesktop = sliderEl.dataset.colsDesktop || '4';

        var options = {
            slidesPerView: MOBILE_MAP[colsMobile] || 1.2,
            spaceBetween: 15,
            navigation: {
                nextEl: sliderEl.querySelector('.swiper-button-next'),
                prevEl: sliderEl.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: sliderEl.querySelector('.swiper-pagination'),
                type: 'progressbar',
            },
            breakpoints: {
                768: {
                    slidesPerView: TABLET_MAP[colsTablet] || 2.5,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: DESKTOP_MAP[colsDesktop] || 3.5,
                    spaceBetween: 30,
                },
            },
            loop: false,
            threshold: 2,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
                releaseOnEdges: true,
            },
        };

        var carousel = new FoxTheme.Carousel(swiperEl, options, [FoxTheme.Swiper.Mousewheel]);
        carousel.init();

        sliderEl.dataset[PREFIX + 'Initialized'] = 'true';
        sliderEl['_' + PREFIX + 'CarouselInstance'] = carousel;

        setTimeout(function () {
            if (carousel.slider) carousel.slider.update();
        }, 200);
    }

    function initAll() {
        document.querySelectorAll('.' + SLIDER_CLASS).forEach(function (slider) {
            initSlider(slider);
        });
    }

    function setupTabListeners() {
        document.querySelectorAll('.' + SLIDER_CLASS).forEach(function (sliderEl) {
            var tabs = sliderEl.closest('tabs-component');
            if (tabs && !tabs.dataset[PREFIX + 'ListenerSet']) {
                tabs.addEventListener('tabChange', function () {
                    setTimeout(function () {
                        tabs.querySelectorAll('.' + SLIDER_CLASS).forEach(function (slider) {
                            if (slider.dataset[PREFIX + 'Initialized'] !== 'true') {
                                initSlider(slider);
                            } else if (slider['_' + PREFIX + 'CarouselInstance'] && slider['_' + PREFIX + 'CarouselInstance'].slider) {
                                slider['_' + PREFIX + 'CarouselInstance'].slider.update();
                            }
                        });
                    }, 150);
                });
                tabs.dataset[PREFIX + 'ListenerSet'] = 'true';
            }
        });
    }

    function init() {
        initAll();
        setupTabListeners();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        setTimeout(init, 100);
    }
})();
